import {Formik} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {Application, ApplicationRecordFormProps, ApplicationStatus} from '../types';
import {stage} from "../../../config/stage";


// FNP-79: form-only flag that gates the programmatic-provisioning fields.
// Stripped from the payload before submit so the GraphQL input shape stays
// clean. When true, applicationStatus is forced to CREATING regardless of
// the radio selection — the state machine drives the lifecycle from there.
type FormValues = Application & {
    provisionAutomatically?: boolean,
};


export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: ApplicationRecordFormProps) => {

    const onSubmit = (values: FormValues) => {
        const {provisionAutomatically, ...rest} = values;

        if (provisionAutomatically) {
            handleSubmit({
                             ...rest,
                             applicationStatus: ApplicationStatus.CREATING,
                         });
            return;
        }

        handleSubmit(rest);
    };

    let initialValues = {provisionAutomatically: false} as FormValues;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
